const i = {
  name: "ArrowCircleRightFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM10.5857 16L11.9999 17.4142L17.4141 12L11.9999 6.58582L10.5857 8.00003L13.5857 11.0001H7V13.0001H13.5857L10.5857 16Z" fill="currentColor"/>
</svg>
  `
};
export {
  i as ArrowCircleRightFilled
};
